import { useMemo } from 'react'

import { useOpenWindow } from '@krp/client-runtime'
import {
  DiagnosticsScreen,
  PLATFORM_WINDOWS,
  makeSelectDiagnosticsVm,
  platformGatewayReady,
  platformGatewayVersion,
  platformResources,
  type DiagnosticsActions,
} from '@krp/platform-ui'

import { useAppSelector } from '../../app/hooks'
import { CONNECTION_FORMS } from '../../composition/connectionForms'
import { useMyAccess } from './useMyAccess'

const selectVersion = platformGatewayVersion.select()
const selectReady = platformGatewayReady.select()
const selectResources = platformResources.select()

/** Binding окна «Диагностика»: шлюз и ресурсы, где диагностика доступна человеку. */
export function DiagnosticsBinding() {
  const openWindow = useOpenWindow()
  const versionSubscription = platformGatewayVersion.useQuerySubscription()
  const readySubscription = platformGatewayReady.useQuerySubscription()
  const resourcesSubscription = platformResources.useQuerySubscription()
  const access = useMyAccess()

  const version = useAppSelector(selectVersion)
  const ready = useAppSelector(selectReady)
  const resources = useAppSelector(selectResources)
  const selectVm = useMemo(() => makeSelectDiagnosticsVm(), [])
  const vm = selectVm({ version, ready, resources, access, forms: CONNECTION_FORMS })

  const refetchVersion = versionSubscription.refetch
  const refetchReady = readySubscription.refetch
  const refetchResources = resourcesSubscription.refetch
  const actions = useMemo<DiagnosticsActions>(
    () => ({
      reload: () => {
        void refetchVersion()
        void refetchReady()
        void refetchResources()
      },
      open: (resourceId) => openWindow(PLATFORM_WINDOWS.resource, { rid: resourceId }),
    }),
    [openWindow, refetchReady, refetchResources, refetchVersion],
  )

  return <DiagnosticsScreen vm={vm} actions={actions} />
}
